/*
 * @Desc: 
 * @Author: lmy
 * @Date: 2025-07-23 15:00:59
 * @LastEditors: lmy
 * @LastEditTime: 2025-07-23 15:01:45
 * @FilePath: \henan-h5\src\utils\auth.js
 */

import Cookies from 'js-cookie'

const TokenKey = 'zhongtai-Params'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    Cookies.set(TokenKey, token)
}

export function removeToken() {
    Cookies.remove(TokenKey)
}
